import React, { useEffect, useState } from "react";
import { useAuth } from "../ReactApp";
import { useLocation, Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import PricesTransporteur from "../components/PricesTransporteur";
import PricesBetonnier from "../components/PricesBetonnier";
import BannerHeader from "../images/register/BANDEAU_INSCRIPTION.png";
import MetaTags from "react-meta-tags";

function RegisterOffersPage() {
  const { user } = useAuth();
  const location = useLocation();

  const [subscriptionType, setSubscriptionType] = useState(null);
  const [subscriptionName, setSubscriptionName] = useState(null);
  const [, setError] = useState("");

  // Montants des offres (en centimes)
  const offerAmounts = {
    pack15: "22500",
    pack30: "30000",
    serenite12: "24999",
    serenite24: "19999",
    pack10: "15000",
    regional: "24999",
    national: "49999",
  };

  // Au montage, on extrait les paramètres de l'URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const subscription_type = searchParams.get("stype");
    const subscription_name = searchParams.get("sname");
    if (subscription_type && subscription_type !== subscriptionType) {
      setSubscriptionType(subscription_type);
    }
    if (subscription_name && subscription_name !== subscriptionName) {
      setSubscriptionName(subscription_name);
    }
  }, [
    location.search,
    subscriptionType,
    subscriptionName,
    setSubscriptionType,
    setSubscriptionName,
  ]);

  const generateReference = () => {
    // On peut par exemple utiliser "REF" + userId + "_" + timestamp
    return `REF${user._id}_${Date.now()}`;
  };

  // À l'intérieur de votre composant SelectionOffre, déclarez ces fonctions :
  const handlePaymentCB = async (subscriptionName) => {
    console.log(`handlePaymentCB called with ${subscriptionName}`);
    try {
      const montant = offerAmounts[subscriptionName];
      const reference = generateReference();
      const url_OK = `${window.location.origin}/profil`;
      const url_KO = `${window.location.origin}/selection-offre?uid=${user._id}&stype=packs&sname=${subscriptionName}`;

      // Envoi des données nécessaires pour la demande de paiement.
      const response = await axios.post(
        process.env.REACT_APP_API_URL + `/v1/payment-request`,
        {
          userId: user._id,
          subscription: subscriptionName, // Pack (donc le produit)
          montant, // montant en centimes
          reference, // référence générée dynamiquement
          url_OK, // URL quand le paiement se déroule correctement
          url_KO, // URL en cas d'échec ou d'annulation
        }
      );

      console.log(response.data);
      const { redirectUrl } = response.data;
      if (redirectUrl) {
        // Redirection côté navigateur vers l'URL de paiement
        window.location.href = redirectUrl;
      } else {
        setError("Erreur : URL de redirection non définie.");
      }
    } catch (err) {
      console.error("Erreur lors de la demande de paiement :", err);
      setError("Erreur lors de la demande de paiement.");
    }
  };

  const handlePaymentAbonnement = async (subscriptionName) => {
    console.log(`handlePaymentAbonnement called with ${subscriptionName}`);
    try {
      const montant = offerAmounts[subscriptionName];

      // Préparer le payload pour la souscription e-mandat.
      const payload = {
        userId: user._id,
        subscription: subscriptionName,
        montant,
      };

      // Appel vers le backend pour lancer la création de la session e-mandat.
      const response = await axios.post(
        process.env.REACT_APP_API_URL + `/v1/mandat-subscribe`,
        payload
      );

      console.log(response.data);
      const { redirectUrl } = response.data;
      if (redirectUrl) {
        // Redirection côté navigateur vers l'URL de paiement
        window.location.href = redirectUrl;
      } else {
        setError("Erreur : URL de redirection non définie.");
      }
    } catch (err) {
      console.error("Erreur lors de la souscription e‑mandat :", err);
      setError("Erreur lors de la souscription e‑mandat.");

      // Récupérer le message soit depuis la réponse API, soit fallback
      const apiError = err.response?.data?.error;
      const message = apiError || err.message || "Erreur inattendue";
      toast.warning(message);
    }
  };

  return (
    <div>
      <MetaTags>
        <title>Louez et Gérer vos Véhicules pour le Béton |</title>
        <meta
          name="description"
          content="Inscrivez-vous sur SoluSpots pour accéder à un large choix de véhicules pour le béton. Rejoignez notre plateforme pour louer, gérer et optimiser vos opérations de chantier dès aujourd'hui."
        />
      </MetaTags>

      <Link to="/">
        <img src={BannerHeader} alt="SoluSpots - La solution en béton" />
      </Link>

      <Container className="my-4">
        {/*
        <Row>
          <Col md={12} lg={12}>
            <h2>Abonnement</h2>
            <p>
              SoluSpots vous propose plusieurs offres. <br />
              Celle-ci est modifiable à tout moment dans votre espace personnel.
            </p>
            <Row className="mt-5" style={{ alignContent: "stretch" }}>
              {type === "transporteur" && (
                <>
                  <Col sm={12} md={6} xl={4} className="mb-4">
                    <div className="register-price-cards">
                      <h2 className="register-price-cards-title">
                        Packs d'annonces
                      </h2>
                      <hr className="register-price-cards-separator" />
                      <p className="register-price-cards-number">
                        225€ - 300€
                      </p>
                      <ul className="register-price-cards-list">
                        <li className="register-price-cards-list-item">
                          15 Spotmonnaies - 225€
                        </li>
                        <li className="register-price-cards-list-item">
                          30 Spotmonnaies - 300€
                        </li>
                      </ul>
                      <div className="register-price-cards-button">
                        {subscription === "pack15" ? (
                          <>
                            <Link
                              to="#"
                              className="register-button-promo-selected"
                            >
                              Pack 15 annonces sélectionné
                            </Link>
                            <button
                              className="register-button-credit"
                              type="button"
                              onClick={() =>
                                (window.location.href =
                                  "URL_DE_LA_PAGE_DE_PAIEMENT_VISA")
                              }
                            >
                              Créditer dès maintenant mon compte
                            </button>
                          </>
                        ) : subscription === "pack30" ? (
                          <>
                            <Link
                              to="#"
                              className="register-button-promo-selected"
                            >
                              Pack 30 annonces sélectionné
                            </Link>
                            <button
                              className="register-button-credit"
                              type="button"
                              onClick={() =>
                                (window.location.href =
                                  "URL_DE_LA_PAGE_DE_PAIEMENT_VISA")
                              }
                            >
                              Créditer dès maintenant mon compte
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => setSubscription("pack15")}
                              className="register-button-promo"
                            >
                              Je choisis le pack 15 annonces
                            </button>
                            <button
                              onClick={() => setSubscription("pack30")}
                              className="register-button-promo"
                            >
                              Je choisis le pack 30 annonces
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6} xl={4} className="mb-4">
                    <div className="register-price-cards">
                      <h2 className="register-price-cards-title">
                        Abonnement Sérénité 12 mois
                      </h2>
                      <hr className="register-price-cards-separator" />
                      <p className="register-price-cards-number">
                        249,99€/mois
                      </p>
                      <ul className="register-price-cards-list">
                        <li className="register-price-cards-list-item">
                          12 mois - 249,99€/mois avec engagement
                        </li>
                      </ul>
                      <div className="register-price-cards-button">
                        {subscription === "serenite12" ? (
                          <Link
                            to="#"
                            className="register-button-promo-selected"
                          >
                            Offre sélectionnée
                          </Link>
                        ) : (
                          <button
                            onClick={() =>
                              setSubscription("serenite12")
                            }
                            className="register-button-promo"
                          >
                            Je choisis l'abonnement 12 mois
                          </button>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6} xl={4} className="mb-4">
                    <div className="register-price-cards">
                      <h2 className="register-price-cards-title">
                        Abonnement Sérénité 24 mois
                      </h2>
                      <hr className="register-price-cards-separator" />
                      <p className="register-price-cards-number">
                        199,99€/mois
                      </p>
                      <ul className="register-price-cards-list">
                        <li className="register-price-cards-list-item">
                          24 mois - 199,99€/mois avec engagement
                        </li>
                      </ul>
                      <div className="register-price-cards-button">
                        {subscription === "serenite24" ? (
                          <Link
                            to="#"
                            className="register-button-promo-selected"
                          >
                            Offre sélectionnée
                          </Link>
                        ) : (
                          <button
                            onClick={() =>
                              setSubscription("serenite24")
                            }
                            className="register-button-promo"
                          >
                            Je choisis l'abonnement 24 mois
                          </button>
                        )}
                      </div>
                    </div>
                  </Col>
                </>
              )}

              {type === "betonnier" && (
                <>
                  <Col sm={12} md={6} xl={4} className="mb-4">
                    <div className="register-price-cards">
                      <h2 className="register-price-cards-title">
                        Pack 10 annonces
                      </h2>
                      <hr className="register-price-cards-separator" />
                      <p className="register-price-cards-number">
                        150€
                      </p>
                      <ul className="register-price-cards-list">
                        <li className="register-price-cards-list-item">
                          10 Spotmonnaies - 150€
                        </li>
                      </ul>
                      <div className="register-price-cards-button">
                        {subscription === "pack10" ? (
                          <>
                            <Link
                              to="#"
                              className="register-button-promo-selected"
                            >
                              Pack 10 annonces sélectionné
                            </Link>
                            <button
                              className="register-button-credit"
                              type="button"
                              onClick={() =>
                                (window.location.href =
                                  "URL_DE_LA_PAGE_DE_PAIEMENT_VISA")
                              }
                            >
                              Créditer dès maintenant mon compte
                            </button>
                          </>
                        ) : (
                          <button
                            onClick={() => setSubscription("pack10")}
                            className="register-button-promo"
                          >
                            Offre sélectionnée
                          </button>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6} xl={4} className="mb-4">
                    <div className="register-price-cards">
                      <h2 className="register-price-cards-title">
                        Abonnement "régional"
                      </h2>
                      <hr className="register-price-cards-separator" />
                      <p className="register-price-cards-number">
                        249,99€/mois avec engagement
                      </p>
                      <ul className="register-price-cards-list">
                        <li className="register-price-cards-list-item">
                          Audit gratuit des coûts sociaux et fiscaux
                        </li>
                      </ul>
                      <div className="register-price-cards-button">
                        {subscription === "betonnierPlus" ? (
                          <>
                            <Link
                              to="#"
                              className="register-button-promo-selected"
                            >
                              Offre sélectionnée
                            </Link>
                            <div className="register-form-field-checkbox mt-2">
                              <Field
                                id="checkbox-spartesAudit-betonnierPlus"
                                type="checkbox"
                                name="spartesAudit"
                              />
                              <label htmlFor="checkbox-spartesAudit-betonnierPlus">
                                Audit gratuit des coûts sociaux et
                                fiscaux avec Spartes.
                              </label>
                            </div>
                          </>
                        ) : (
                          <Link
                            onClick={() =>
                              setSubscription("betonnierPlus")
                            }
                            className="register-button-promo"
                          >
                            Je choisis cette offre
                          </Link>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col sm={12} md={6} xl={4} className="mb-4">
                    <div className="register-price-cards">
                      <h2 className="register-price-cards-title">
                        Abonnement "national"
                      </h2>
                      <hr className="register-price-cards-separator" />
                      <p className="register-price-cards-number">
                        499,99€/mois avec engagement
                      </p>
                      <ul className="register-price-cards-list">
                        <li className="register-price-cards-list-item">
                          Audit gratuit des coûts sociaux et fiscaux
                        </li>
                      </ul>
                      <div className="register-price-cards-button">
                        {subscription === "betonnierPro" ? (
                          <>
                            <Link
                              to="#"
                              className="register-button-promo-selected"
                            >
                              Offre sélectionnée
                            </Link>
                            <div className="register-form-field-checkbox mt-2">
                              <Field
                                id="checkbox-spartesAudit-betonnierPro"
                                type="checkbox"
                                name="spartesAudit"
                              />
                              <label htmlFor="checkbox-spartesAudit-betonnierPro">
                                Audit gratuit avec Spartes.
                              </label>
                            </div>
                          </>
                        ) : (
                          <Link
                            onClick={() =>
                              setSubscription("betonnierPro")
                            }
                            className="register-button-promo"
                          >
                            Je choisis cette offre
                          </Link>
                        )}
                      </div>
                    </div>
                  </Col>
                </>
              )}
            </Row>
          </Col>
        </Row>
*/}

        {user && user.role === "transporteur" && (
          <PricesTransporteur
            defaultType={subscriptionType}
            onPaymentAbonnement={handlePaymentAbonnement}
            onPaymentCB={handlePaymentCB}
          />
        )}

        {user && user.role === "betonnier" && (
          <PricesBetonnier
            defaultType={subscriptionType}
            onPaymentAbonnement={handlePaymentAbonnement}
            onPaymentCB={handlePaymentCB}
          />
        )}

        {user && user.role === "transporteur" && !user.subscription ? (
          <Row>
            <Col sm={12} className="my-4 text-center">
              <a href="/resultat-chantier">J'ignore cette étape</a>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col sm={12} className="my-4 text-center">
              <a href="/resultat">J'ignore cette étape</a>
            </Col>
          </Row>
        )}

        {/*
        <Row>
          <Col>
            <div className="register-footer">
              <div className="register-button">
                <button
                  className="register-button-next"
                  type="button"
                  onClick={() => {
                    // Vérification simplifiée de la case CGV
                    const cgvChecked = document.getElementById(
                      "checkbox-conformitecgv"
                    )?.checked;
                    if (cgvChecked) {
                      // Rediriger vers la page de connexion ou une autre page
                      navigate("/connexion");
                    } else {
                      navigate("/connexion");
                    }
                  }}
                >
                  {document.getElementById("checkbox-conformitecgv")
                    ?.checked
                    ? "Valider l'abonnement"
                    : "Passer cette étape"}
                </button>

                {user._id ? (
                  <p>
                    <strong>$user._id: {user._id}</strong>
                    <br />
                    Choix: {subscription || "vide"}
                  </p>
                ) : (
                  <p>
                    <strong>$userId vide.</strong>
                  </p>
                )}

                <button
                  className="button-passer"
                  type="button"
                  onClick={() => navigate("/")}
                >
                  Passer
                </button>
                <button
                  className="button-paiement-cb"
                  type="button"
                  onClick={handlePaymentCB}
                >
                  Paiement CB
                </button>
                <button
                  className="button-paiement-abonnement"
                  type="button"
                  onClick={handlePaymentAbonnement}
                >
                  Paiement Abonnement
                </button>
              </div>
            </div>
          </Col>
        </Row>
*/}
      </Container>
    </div>
  );
}

export default RegisterOffersPage;
